import { GridColTypeDef } from "@mui/x-data-grid-pro";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useEditableCellLink } from "components/DataGrid/editableCellLink";

interface UrlFunctionParams<T> {
  value: unknown;
  row: T;
}

type UrlFunction<T> = (params: UrlFunctionParams<T>) => string | null;

function CellLink({ to, children }: { to: string; children: ReactNode }) {
  const { onClick } = useEditableCellLink(to);
  return (
    <Link to={to} onClick={onClick}>
      {children}
    </Link>
  );
}

// if urlFn returns null, the cell will be rendered without a link component wrapping it.
export function linkColDef<T>(urlFn: UrlFunction<T>): GridColTypeDef {
  return {
    renderCell({ row, value }) {
      if (!value || !row) return null;
      const to = urlFn({ value, row });
      if (!to) return value;
      return <CellLink to={to}>{value}</CellLink>;
    },
  };
}
